import { Component } from 'react';

class GeriatricDepressionScale extends Component {
  render() {
    return <h1>Geriatric Depression Scale</h1>;
  }
}

export default GeriatricDepressionScale;
